export const FETCH_F1_MENU_ITEMS = "FETCH_F1_MENU_ITEMS";
export const FETCH_F1_MENU_ITEMS_PENDING = "FETCH_F1_MENU_ITEMS_PENDING";
export const FETCH_F1_MENU_ITEMS_REJECTED = "FETCH_F1_MENU_ITEMS_REJECTED";
export const FETCH_F1_MENU_ITEMS_FULFILLED = "FETCH_F1_MENU_ITEMS_FULFILLED";
